// extracted by mini-css-extract-plugin
export var container = "GiftingHeader-module__container___haQrS";
export var banner = "GiftingHeader-module__banner___lrIpz";
export var featuresAndChoose = "GiftingHeader-module__featuresAndChoose___hhzvO";
export var featureHeader = "GiftingHeader-module__featureHeader___PNCjB";
export var features = "GiftingHeader-module__features____AmPc";
export var checkMarkIcon = "GiftingHeader-module__checkMarkIcon___yjBG3";
export var bulletList = "GiftingHeader-module__bulletList___OxOMW";
export var mobileBulletList = "GiftingHeader-module__mobileBulletList___TL7UG";
export var desktopBulletList = "GiftingHeader-module__desktopBulletList___uczyo";
export var planType = "GiftingHeader-module__planType___qekic";